<template>
  <v-card class="card-quote" elevation="0">
    <v-card-text>
      <v-row class="px-5">
        <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
          <!-- <v-img src="img/icons/quote_client_data.png" width="178" contain></v-img> -->
          <div
            class="d-flex flex-row align-center">
            <v-sheet
              color="title-icon"
              class="d-flex justify-center align-center rounded-circle"
              height="38"
              width="38">
              <v-icon color="title-icon-background" size="25">fas fa-male</v-icon>
            </v-sheet>
            <span
              class="title-foreground--text font-weight-medium ml-2">
              Dados do Cliente
            </span>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="CNPJ"
            maxlength="18"
            v-model="juridicalPerson.cnpj"
            v-mask="$util.formmasks.cnpj"
            :rules="[$util.formrules.cnpj]"
            @input="() => setJuricalPersonCNPJ(juridicalPerson.cnpj)"
            :readonly="iReadOnly"
            validate-on-blur
            outlined
            :clearable="!iReadOnly"
            dense
          />
        </v-col>
        <v-col cols="12" md="6" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Razão Social"
            v-model="juridicalPerson.legalName"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonLegalName(juridicalPerson.legalName)"
            :readonly="iReadOnly"
            maxlength="255"
            validate-on-blur
            outlined
            :clearable="!iReadOnly"
            dense
          />
        </v-col>
        <v-col cols="12" md="3" class="component-col pl-md-1 py-0 my-0">
          <v-autocomplete
            label="Cidade"
            :items="cities"
            v-model="juridicalPerson.city"
            :rules="[$util.formrules.requiredSelected]"
            :search-input.sync="searchCity"
            :loading="isloadingCities"
            @change="() => setJuricalPersonCity(juridicalPerson.city)"
            :readonly="iReadOnly"
            :disabled="isDisabledOnSearch"
            item-text="text"
            item-value="id"
            validate-on-blur
            outlined
            dense
            hide-no-data
            return-object
          />
        </v-col>

        <v-col cols="12" md="3" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Nome do Contato"
            v-model="juridicalPerson.nameContact"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonName(juridicalPerson.nameContact)"
            :readonly="iReadOnly"
            maxlength="255"
            validate-on-blur
            outlined
            :clearable="!iReadOnly"
            dense
          />
        </v-col>
        <v-col cols="12" md="3" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Telefone"
            v-model="juridicalPerson.phoneContact"
            v-mask="$util.formmasks.phoneWithDDD"
            :rules="[$util.formrules.phone]"
            @input="() => setJuricalPersonPhone(juridicalPerson.phoneContact)"
            :readonly="iReadOnly"
            maxlength="15"
            validate-on-blur
            outlined
            :clearable="!iReadOnly"
            dense
          />
        </v-col>
        <v-col cols="12" md="6" class="component-col pl-md-1 py-0 my-0">
          <v-text-field
            label="E-mail"
            maxlength="255"
            v-model="juridicalPerson.emailContact"
            :rules="[$util.formrules.email, $util.formrules.required]"
            @input="() => setJuricalPersonEmail(juridicalPerson.emailContact)"
            :readonly="iReadOnly"
            validate-on-blur
            outlined
            :clearable="!iReadOnly"
            dense
          />
        </v-col>
        <v-col cols="12" md="1" class="component-col-text d-flex d-sm-flex d-md-none d-lg-none d-xl-none py-0 my-0">
          <p style="font-size: 14px;" class="pt-md-2 pb-0 mb-0 text-truncate">Com cópia para</p>
        </v-col>
        <v-col cols="12" md="1" class="component-col d-none d-md-flex py-0 my-0 text-md-right">
          <p style="font-size: 14px;" class="pt-md-2 pb-0 mb-0 text-truncate">Com cópia para</p>
        </v-col>
        <v-col cols="12" md="5" class="component-col px-md-0 mx-md-0 py-0 my-0">
          <v-text-field
            label="E-mail"
            maxlength="255"
            v-model="juridicalPerson.emailWithCopy"
            :rules="[$util.formrules.email]"
            @input="() => setJuricalPersonEmailWithCopy(juridicalPerson.emailWithCopy)"
            :readonly="iReadOnly"
            validate-on-blur
            outlined
            :clearable="!iReadOnly"
            dense
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import CityService from "@/services/odoo/CityService";

export default {
  name: 'juridicalPersonData',
  data: () => ({
    isDisabledOnSearch: false,
    iReadOnly: false,
    isloadingCities: false,
    searchCity: null,
    cities: [],
    juridicalPerson: {
      cnpj: null,
      legalName: null,
      city: null,
      nameContact: null,
      phoneContact: null,
      emailContact: null,
      emailWithCopy: null,
    }
  }),
  watch: {
    'juridicalPerson.cnpj'(val) {
      if (val && val !== val.toUpperCase()) {
        this.juridicalPerson.cnpj = val.toUpperCase();
      }
    },
    searchCity(newValue) {
      if(newValue && newValue.trim().length >= 3) {
        this.fetchCitiesEntriesDebounced();
      }
    }
  },
  methods: {
    ...mapMutations(["showmsg"]),
    ...mapActions(['setJuricalPersonCNPJ', 'setJuricalPersonLegalName', 'setJuricalPersonCity', 
      'setJuricalPersonName', 'setJuricalPersonPhone', 'setJuricalPersonEmail', 'setJuricalPersonEmailWithCopy']),
    fetchCitiesEntriesDebounced() {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.isDisabledOnSearch = true;
        this.loadCitiesBySearch();
      }, 500);
    },
    async loadCitiesBySearch() {
      if(this.cities.some(city => city.text === this.searchCity)) {
        this.isloadingCities = false;
        this.isDisabledOnSearch = false;
        return;
      }
      
      this.cities = [];
      this.isloadingCities = true;
      
      if(this.searchCity && this.searchCity.trim().length >= 3) {
        await this._cityservice.FindAll(this.searchCity)
          .then((response) => {
            if (response.data && response.data.records && response.data.records.length) {
              this.cities = response.data.records.map(item => ({
                ...item,
                text: item.name && item.state_id ? `${item.name}, ${item.state_id.code}` : (item.name ? item.name : '-')
              }));
            } else {
              this.clearWhenNotFoundCityOrError();
              this.showmsg({text: `Nenhuma cidade foi encontrada com o nome informado.`, type: 'warning'});
            }
          })
          .catch(() => {
            this.clearWhenNotFoundCityOrError();
            this.showmsg({text: 'Ocorreu um erro ao tentar carregar as cidades.', type: 'error'});
          })
          .finally(() => {
            this.isDisabledOnSearch = false;
          });
      } else {
        this.isDisabledOnSearch = false;
      }
      
      this.isloadingCities = false;
    },
    clearWhenNotFoundCityOrError() {
      this.cities = [];
      this.juridicalPerson.city = null;
      this.setJuricalPersonCity(null);
      this.$emit('selectProject', null);
    },
    clearFields() {
      this.juridicalPerson = {
        cnpj: null,
        legalName: null,
        city: null,
        nameContact: null,
        phoneContact: null,
        emailContact: null,
        emailWithCopy: null,
      }
      
      this.setJuricalPersonCNPJ(null);
      this.setJuricalPersonLegalName(null);
      this.setJuricalPersonCity(null);
      this.setJuricalPersonName(null);
      this.setJuricalPersonPhone(null);
      this.setJuricalPersonEmail(null);
      this.setJuricalPersonEmailWithCopy(null);
      
      this.isloadingCities = false;
      this.cities = [];
    },
    async reloadDataFromSessionStorage() {
      const key = 'quoteDataObj';
      if(sessionStorage.getItem(key)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(key)));
        const juricalPersonObj = quoteData ? quoteData.juridicalPersonObj : null;
        
        this.juridicalPerson.cnpj = juricalPersonObj.cnpj;
        this.juridicalPerson.legalName = juricalPersonObj.legalName;
        this.juridicalPerson.nameContact = juricalPersonObj.nameContact;
        this.juridicalPerson.phoneContact = juricalPersonObj.phoneContact;
        this.juridicalPerson.emailContact = juricalPersonObj.emailContact;
        this.juridicalPerson.emailWithCopy = juricalPersonObj.emailWithCopy;
        
        this.setJuricalPersonCNPJ(this.juridicalPerson.cnpj);
        this.setJuricalPersonLegalName(this.juridicalPerson.legalName);
        this.setJuricalPersonName(this.juridicalPerson.nameContact);
        this.setJuricalPersonPhone(this.juridicalPerson.phoneContact);
        this.setJuricalPersonEmail(this.juridicalPerson.emailContact);
        this.setJuricalPersonEmailWithCopy(this.juridicalPerson.emailWithCopy);
        
        this.searchCity = juricalPersonObj.city ? juricalPersonObj.city.name : null;
        await this.loadCitiesBySearch();
        
        this.juridicalPerson.city = juricalPersonObj.city ? juricalPersonObj.city : null;
        this.setJuricalPersonCity(this.juridicalPerson.city);
      }
    },
    loadDataByQueryParam() {
      this.juridicalPerson.cnpj = this.$route.query.cnpj ? this.$util.removeMask(this.$route.query.cnpj) : null;
      this.juridicalPerson.legalName = this.$route.query.legal_name;
      this.juridicalPerson.nameContact = this.$route.query.name;
      this.juridicalPerson.phoneContact = this.$route.query.phone ? this.$util.removeMask(this.$route.query.phone) : null;
      if(this.juridicalPerson.phoneContact && this.juridicalPerson.phoneContact.startsWith('55')) {
        this.juridicalPerson.phoneContact = this.juridicalPerson.phoneContact.length > 2 ? this.juridicalPerson.phoneContact.substring(2) : null
      }
      this.juridicalPerson.emailContact = this.$route.query.email;
      this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');

      this.setJuricalPersonCNPJ(this.juridicalPerson.cnpj);
      this.setJuricalPersonLegalName(this.juridicalPerson.legalName);
      this.setJuricalPersonName(this.juridicalPerson.nameContact);
      this.setJuricalPersonPhone(this.juridicalPerson.phoneContact);
      this.setJuricalPersonEmail(this.juridicalPerson.emailContact);
    }
  },
  computed: {},
  beforeCreate() {
    this._cityservice = new CityService();
  },
  async created() {
    this.loadDataByQueryParam();
    await this.reloadDataFromSessionStorage();
  },
};
</script>

<style scoped>

.component-col {
  height: 62px !important;
}

.component-col-text {
  height: 40px !important;
}

</style>
